import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  public error$ = new BehaviorSubject<string>(null);

  public setError(error: Error) {
    this.error$.next(error.message);
  }

  public clearError() {
    this.error$.next(null);
  }
}
